<template>
 <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div class="container">
      <div class="tabs js-tabs">
        <div class="col-auto">
          <div v-html="vars.titleHtml"> </div>
        </div>

        <div data-anim="slide-up delay-1" class="tabs__content pt-60 md:pt-30 js-tabs-content">

          <!-- Exterior Panel -->
          <div class="tabs__pane -tab-item-1 is-tab-el-active">
            <div class="relative js-section-slider"
                 data-gap="30"
                 data-slider-cols="xl-2 lg-2 md-2 sm-1 base-1">
              <div class="swiper-wrapper">
                <div
  class="swiper-slide tw-flex tw-flex-col"
  v-for="(card, index) in cards"
  :key="index"
>
  <!-- Resim kısmı -->
  <div >
    <library-image :src="card.photo" alt="exterior image" class="img-ratio" />
  </div>

  
  <div class=" tw-flex-col tw-flex-1 tw-mt-4">
    <h6 class="imageCard__title text-dark-1 tw-mb-4 tw-line-clamp-1">
      <b>{{ card.title }}</b>
    </h6>

    
    <p class="imageCard__text text-dark-1 tw-mb-6 tw-line-clamp-3 tw-min-h-[6rem]">
      {{ card.description }}
    </p>

   
    <button :class="`n-${card.button_type}`" class="tw-mt-auto">
      {{ card.button_label }}
    </button>
  </div>
</div>
              </div>
              <div class="d-flex mt-60 md:mt-30">
                <button class="sliderNav -prev -transparent js-prev">
                  <i class="icon-left-arrow"></i>
                </button>
                <button class="sliderNav -next -transparent ml-20 js-next">
                  <i class="icon-right-arrow"></i>
                </button>
              </div>
            </div>
          </div>

        
        

        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'OurGuide',
  mixins: [ComponentMixin],

  computed: {
   
    // Cards array expects { photo: string, title: string }
    cards() {
      return this.groupedVariables.cards;
    },
    buttons() {
      return this.groupedVariables.buttons;
    }
  },
});
</script>
